
$(document).ready(function() {
    
    var $body = $('body'),
        $desktopQueryInput = $('.desktop-search__query'),
        $mobileQueryInput = $('.mobile-search__query'),
        desktopToggleClass = 'desktop-search-toggle',
        mobileToggleClass = 'header-mobile__toggle--search';

    // Toggle mobile & desktop search
    $(document).on('click', '.' + mobileToggleClass + ', .' + desktopToggleClass, function(e) {
        e.preventDefault();

        $body.removeClass('mobile-menu-open');
        $body.toggleClass('search-open');

        // If the desktop toggle was clicked, focus on the desktop search field
        if($(this).hasClass(desktopToggleClass)) {
            $desktopQueryInput.focus();
        }

        // If the mobile toggle was clicked, focus on the mobile search field
        else if($(this).hasClass(mobileToggleClass)) {
            $mobileQueryInput.focus();
        }
    });
});